import React, { forwardRef } from 'react'
import { Input as MuiInput, InputOwnerState, InputOwnProps } from '@mui/base/Input'
import clsx from 'clsx'
import classes from './Input.module.scss'

export type InputProps = {
  isCompact?: boolean
  color?: 'neutral' | 'danger'
  multiline?: boolean
  min?: number
  step?: number
} & Omit<InputOwnProps, 'multiline'>

const Input = forwardRef<HTMLDivElement, InputProps>(function CustomInput(
  { isCompact = false, color = 'neutral', min, step, ...props },
  ref
) {
  const slotProps = {
    root: (ownerProps: InputOwnerState) => ({
      className: clsx(classes.root, {
        [classes.focused]: ownerProps.focused,
        [classes.disabled]: ownerProps.disabled,
        [classes.compact]: isCompact,
        [classes.neutral]: color === 'neutral',
        [classes.danger]: color === 'danger',
        [classes.multiline]: props.multiline,
      }),
    }),
    input: () => ({
      className: classes.input,
      min,
      step,
    }),
  }

  // @ts-expect-error MuiInput props for multiline are broken
  return <MuiInput slotProps={slotProps} {...props} ref={ref} />
})

export default Input
